"use strict";

var _interopRequireDefault = require("/opt/build/repo/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _api = _interopRequireDefault(require("@/api"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'EditRoleDialog',
  props: {
    role: {
      type: Object,
      default: undefined
    },
    permissionsTree: {
      type: Array,
      default: undefined
    }
  },
  data: function data() {
    return {
      visible: true,
      dirty: false,
      loading: false,
      editRoleForm: {
        label: this.role ? this.role.label : '',
        permissions: this.role ? this.role.permissions.map(function (permission) {
          return permission._id;
        }) : []
      },
      editRoleRules: {
        label: [{
          type: 'string',
          required: true,
          trigger: ['change', 'blur'],
          message: '请输入名称',
          transform: function transform(value) {
            return value.trim();
          }
        }],
        permissions: [{
          type: 'array',
          required: true,
          trigger: 'change',
          message: '请至少选择一个角色权限'
        }]
      }
    };
  },
  computed: {
    defaultPermissions: function defaultPermissions() {
      return this.role ? this.role.permissions.map(function (permission) {
        return permission._id;
      }) : [];
    }
  },
  methods: {
    handleClose: function handleClose(done) {
      var _this = this;

      if (this.dirty) {
        this.$confirm('确定取消所做的更改么？', {
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        }).then(function () {
          _this.resetForm();

          _this.$emit('closeDialog');

          if (done) done();
        }).catch(function () {});
      } else {
        this.resetForm();
        this.$emit('closeDialog');
        if (done) done();
      }
    },
    handleInputChange: function handleInputChange() {
      this.dirty = true;
    },
    resetForm: function resetForm() {
      this.$refs.editRoleForm.resetFields();
      this.dirty = false;
    },
    handlePermissionsTreeChange: function handlePermissionsTreeChange() {
      this.dirty = true;
      this.editRoleForm.permissions = this.$refs.permissionsTree.getCheckedNodes().map(function (node) {
        return node._id;
      });
    },
    handleUpdateRole: function handleUpdateRole() {
      var _this2 = this;

      if (!this.dirty) {
        this.resetForm();
        this.$emit('closeDialog');
        return true;
      }

      this.$refs.editRoleForm.validate(function (valid) {
        if (valid) {
          _this2.loading = true;

          _api.default.updateRole(_this2.role._id, {
            label: _this2.editRoleForm.label || undefined,
            permissions: _this2.editRoleForm.permissions
          }).then(function () {
            _this2.loading = false;

            _this2.resetForm();

            _this2.$emit('roleUpdated');

            _this2.$emit('closeDialog');
          }).catch(function () {
            _this2.loading = false;
          });
        }
      });
    }
  }
};
exports.default = _default;